import { render, staticRenderFns } from "./data-abstract-unit.vue?vue&type=template&id=edbc13cc&scoped=true"
import script from "./data-abstract-unit.vue?vue&type=script&lang=js"
export * from "./data-abstract-unit.vue?vue&type=script&lang=js"
import style0 from "./data-abstract-unit.vue?vue&type=style&index=0&id=edbc13cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbc13cc",
  null
  
)

export default component.exports